import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvestmentGraphicComponent } from './investment-graphic.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ InvestmentGraphicComponent ],
    declarations: [ InvestmentGraphicComponent ],
})
export class InvestmentGraphicModule {}
